import React, { FC, useContext, useState, useEffect } from "react";
import "./styles.scss";
import { useNavigate } from "@reach/router";
import { UserContext } from "../../UserContext";
import { IAnyProps } from "../../Types/Types";
import ConnectSubscribeButtonGroup from "../../ConnectSubscribeButtonGroup";
import { CustomModalContext } from "../../CustomModalContext/CustomModalContext";
import loadable from "@loadable/component";
import { Shimmer } from "../../Shimmers";
import PageNotFound from "ErrorPages/PageNotFound";

const MetricsModal = loadable(
  () =>
    import(
      /* webpackChunkName: "MetricsModal" */ "../../MetricsModalComponent/MetricsModal"
    )
);
import ProfileAnalyticsSection from "../ProfileAnalyticsSection/ProfileAnalyticsSection";

interface IProps {
  company: IAnyProps;
  companyIsLoaded: boolean;
  companyNotFound?: boolean;
}

const CompanyDetailHeader: FC<IProps> = (props: IProps) => {
  const { company, companyIsLoaded, companyNotFound } = props;

  // @ts-ignore
  const [userContext] = useContext(UserContext);
  const navigate = useNavigate();

  const [displayEditButton, setDisplayEditButton] = useState(false);

  useEffect(() => {
    if (!company) {
      return;
    }

    if (!userContext.companiesUserHasAdminAccessTo) {
      return;
    }

    for (let i in userContext.companiesUserHasAdminAccessTo) {
      if (
        company.company_id ===
        userContext.companiesUserHasAdminAccessTo[i].company_id
      ) {
        setDisplayEditButton(true);
        break;
      }
    }
  }, [userContext.companiesUserHasAdminAccessTo, company]);

  const { setShowModal, showModal } = useContext(CustomModalContext);

  const onOpenMetrics = () => {
    setShowModal(true);
  };

  return (
    <>
      {showModal && <MetricsModal />}

      {companyIsLoaded === true && (
        <div className="ps-company-detail-header">
          {/*FIXME: metrics-modal demo button*/}
          {/* <button
            className="ps-company-detail-header__metrics-demo-btn"
            onClick={() => onOpenMetrics()}
          >
            Metrics
          </button> */}

          <div
            style={
              company &&
              company["profile_header_image_url"] &&
              company["profile_header_image_url"].trim() !== ""
                ? {
                    backgroundImage: `url(${
                      company && company["profile_header_image_url"]
                    })`,
                  }
                : {}
            }
            className="ps-company-detail-header__wallpaper"
          >
            <div className="ps-company-detail-header__button-group-container">
              <div className="ps-company-detail-header__connect-button-container">
                <ConnectSubscribeButtonGroup
                  company={company}
                  respectSubscribeInUrl={true}
                  buttonClassName="btn ps-btn--primary ps-company-detail-header__connect-subscribe"
                />
              </div>
              {displayEditButton && (
                <div style={{}}>
                  <button
                    onClick={() => {
                      navigate(`/${company.name}/edit/basic-info`);
                    }}
                    className="btn ps-btn--white"
                  >
                    Edit
                  </button>
                </div>
              )}
            </div>
            <div className="container" style={{ marginTop: "65px" }}>
              <div className="ps-company-detail-header__company-logo-container">
                {company && company["logo_url"] ? (
                  <img
                    className="ps-company-detail-header__company-logo"
                    src={company && company["logo_url"]}
                    alt={company && company["display_name"]}
                  />
                ) : (
                  <span className="ps-company-detail-header__company-name">
                    {company && company["display_name"]}
                  </span>
                )}
              </div>
            </div>
          </div>
          <div className="container">
            <div className="ps-company-detail-header__company-info-container">
              <div className="ps-company-detail-header__company-info-row">
                <h2 className="ps-company-detail-header__company-name-text">
                  {company && company["display_name"]}
                </h2>
                {/* <span className="ps-company-detail-header__company-chip">
              {company && company["status"] ? "DOING BUSINESS" : "UNKNOWN"}
            </span> */}
              </div>
              <p className="ps-company-detail-header__company-tagline">
                {company && company["short_description"]}
              </p>
              {/* <p className="ps-company-detail-header__quick-info-container">
                <span className="ps-company-detail-header__quick-info">
                  {"5+ TEAM"}
                </span>
                <i className="ps-company-detail-header__quick-info-separator" />
                <span className="ps-company-detail-header__quick-info">
                  {"Pre Seed"}
                </span>
                <i className="ps-company-detail-header__quick-info-separator" />
                <span className="ps-company-detail-header__quick-info">
                  {"$500k raised"}
                </span>
              </p> */}
            </div>
          </div>
          {/* <ProfileAnalyticsSection companyId={company.company_id} /> */}
        </div>
      )}

      {companyIsLoaded === false && companyNotFound === false && (
        <div className="ps-company-detail-header">
          <Shimmer
            shimmerStyles={{
              width: "100%",
              height: "203px",
            }}
          />

          <div className="container" style={{ marginTop: "-50px" }}>
            <div className="ps-company-detail-header__company-logo-container">
              <Shimmer
                shimmerStyles={{
                  width: "94px",
                  height: "94px",
                  borderRadius: "50%",
                }}
              />
            </div>
          </div>

          <div className="container">
            <div className="ps-company-detail-header__company-info-container--loading">
              <div className="ps-company-detail-header__company-info-row">
                <div className="ps-company-detail-header__company-name-text">
                  <Shimmer
                    shimmerStyles={{
                      width: "250px",
                      height: "30px",
                      borderRadius: "5px",
                    }}
                  />
                </div>
              </div>
              <div className="ps-company-detail-header__company-tagline">
                <Shimmer
                  shimmerStyles={{
                    width: "500px",
                    height: "20px",
                    borderRadius: "5px",
                  }}
                />
              </div>
              {/* <div className="ps-company-detail-header__quick-info-container">
                <span className="ps-company-detail-header__quick-info">
                  <Shimmer
                    shimmerStyles={{
                      width: "65px",
                      height: "14px",
                      borderRadius: "5px",
                    }}
                  />
                </span>
                <i className="ps-company-detail-header__quick-info-separator" />
                <span className="ps-company-detail-header__quick-info">
                  <Shimmer
                    shimmerStyles={{
                      width: "65px",
                      height: "14px",
                      borderRadius: "5px",
                    }}
                  />
                </span>
                <i className="ps-company-detail-header__quick-info-separator" />
                <span className="ps-company-detail-header__quick-info">
                  <Shimmer
                    shimmerStyles={{
                      width: "65px",
                      height: "14px",
                      borderRadius: "5px",
                    }}
                  />
                </span>
              </div> */}
            </div>
          </div>
        </div>
      )}

      {companyNotFound === true && (
        <div>
          <PageNotFound />
        </div>
      )}
    </>
  );
};

export default CompanyDetailHeader;
